import { clientAxios } from '@/plugins/axios'

const baseURL = '/v1/product'

export const getProducts = (params) => clientAxios.get(baseURL, { params })
export const getProductDetail = (id) => clientAxios.get(`${baseURL}/detail/${id}`)
export const getProductSku = (params) => clientAxios.get(`${baseURL}/sku/list`, { params })
